import { render, staticRenderFns } from "./AdItemPlacementUnitsHandler.vue?vue&type=template&id=04186e21&scoped=true&"
import script from "./AdItemPlacementUnitsHandler.vue?vue&type=script&lang=ts&"
export * from "./AdItemPlacementUnitsHandler.vue?vue&type=script&lang=ts&"
import style0 from "./AdItemPlacementUnitsHandler.vue?vue&type=style&index=0&id=04186e21&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04186e21",
  null
  
)

export default component.exports